(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sajaya-best-sellers"] && !Shopify.designMode) return;
  try {
    
/* No Liquid in here — Shopify rejects Liquid inside the javascript tag.
   All data arrives through HTML data attributes instead.

   NOTE: this block runs once per section TYPE, not per instance, so it
   loops over every instance on the page rather than grabbing a fixed ID. */

(function () {

  /* Pulls one section's markup out of a returned HTML string. DOMParser
     is the safe way — regex on HTML breaks on unexpected nesting. */
  function extractSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* THE BLANK-DRAWER FIX.
     When the cart is empty at page load, Dawn renders
     <cart-drawer class="drawer is-empty">, and its CSS hides the drawer
     contents while that class is present. Dawn's renderContents only
     strips is-empty from the inner div, not the host element — so the
     first add injects correct markup into a container CSS still hides.
     That's why the drawer looked blank, and why it worked after a
     reload: the cart was no longer empty, so the class never rendered. */
  function clearEmptyState() {
    var host = document.querySelector('cart-drawer');
    if (host) host.classList.remove('is-empty');

    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }

  function openDrawer(sections) {
    clearEmptyState();   /* Must run BEFORE rendering, or fresh markup
                            lands inside a hidden container */

    var drawer = document.querySelector('cart-drawer');

    /* PATH 1 — Dawn's own render method. Preferred: it handles the
       markup swap and open animation the way the theme expects. */
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
      clearEmptyState();   /* Again after render — Dawn's markup can
                              reintroduce the class */
      return true;
    }

    /* PATH 2 — manual swap, for theme versions without that method. */
    var host = document.querySelector('#CartDrawer');
    if (host && sections && sections['cart-drawer']) {
      var fresh = extractSection(sections['cart-drawer'], '#CartDrawer');
      if (fresh) host.innerHTML = fresh;

      clearEmptyState();

      if (drawer) {
        drawer.classList.add('animate', 'active');
        if (typeof drawer.open === 'function') drawer.open();
      }
      document.body.classList.add('overflow-hidden');
      return true;
    }

    return false;   /* Neither path worked — caller falls back to cart */
  }

  /* Refreshes the count bubble on the header cart icon. */
  function refreshBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    var fresh = extractSection(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && fresh) bubble.innerHTML = fresh;
  }

  function initSection(root) {
    if (root.dataset.sjyReady) return;   /* Guard against double-binding
                                            when the editor re-renders */
    root.dataset.sjyReady = '1';

    /* Routes passed in from Liquid via data attributes. Falls back to
       the default paths if an attribute is somehow missing. */
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl    = root.getAttribute('data-cart-url') || '/cart';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.sjy-bs__atc');
      if (!btn) return;

      var variantId = btn.getAttribute('data-sjy-add');
      if (!variantId) return;   /* Sold-out button has no ID — ignore */

      e.preventDefault();       /* Stops the plain form submit, which
                                   would navigate away to the cart */

      btn.classList.add('is-loading');   /* Blocks double-clicks */
      var original = btn.textContent;
      btn.textContent = 'Adding…';

      function reset() {
        btn.classList.remove('is-loading');
        btn.textContent = original;
      }

      /* TWO-STEP, deliberately.
         Step 1 adds the item. Step 2 fetches the drawer markup in a
         separate request. Asking for 'sections' inside the POST saves a
         round trip, but renders sections against the root URL rather
         than the current page and returns stale markup in some setups —
         the other half of the blank-drawer problem. */

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {   /* Shopify returns 'status' only on error,
                                e.g. stock ran out mid-session */
          reset();
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = original; }, 2000);
          return null;
        }

        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        if (!sections) return;   /* Error path handled above */

        reset();
        refreshBubble(sections);

        /* If the drawer can't open, send them to the cart page rather
           than silently doing nothing. */
        if (!openDrawer(sections)) window.location.href = cartUrl;
      })
      .catch(function () {
        /* Network failure — fall back so the add isn't lost */
        reset();
        window.location.href = cartUrl;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sjy-bs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor re-renders sections without a page reload, which
     would otherwise leave the new markup unbound. */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sajaya-other-collections"] && !Shopify.designMode) return;
  try {
    
/* No Liquid in here — Shopify rejects Liquid inside the javascript tag.
   All data arrives through HTML data attributes instead.

   NOTE: this block runs once per section TYPE, not per instance, so it
   loops over every instance on the page rather than grabbing a fixed ID.
   That's what makes the section safe to add twice. */

(function () {

  /* ─── DRAWER HELPERS (shared by all instances) ──────────── */

  /* Pulls one section's markup out of a returned HTML string. DOMParser
     is the safe way — regex on HTML breaks on unexpected nesting. */
  function extractSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* THE BLANK-DRAWER FIX.
     When the cart is empty at page load, Dawn renders
     <cart-drawer class="drawer is-empty">. Its CSS hides the drawer's
     contents while that class is present. Dawn's own renderContents only
     strips is-empty from the inner .drawer__inner div, not from the host
     element — so the first add injects correct markup into a container
     that CSS is still hiding. That is why the drawer looked blank, and
     why it worked after a reload: on reload the cart is no longer empty,
     so the class is never rendered in the first place. */
  function clearEmptyState() {
    var host = document.querySelector('cart-drawer');
    if (host) host.classList.remove('is-empty');

    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    var emptyBlock = document.querySelector('cart-drawer .cart-drawer__warnings');
    if (emptyBlock) emptyBlock.classList.remove('cart-drawer__warnings--focused');
  }

  function openDrawer(sections) {
    clearEmptyState();   /* Must run BEFORE rendering, or the freshly
                            injected markup lands in a hidden container */

    var drawer = document.querySelector('cart-drawer');

    /* PATH 1 — Dawn's own render method. Preferred: it handles the markup
       swap and the open animation exactly the way the theme expects. */
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
      clearEmptyState();   /* Again after render — Dawn's own markup can
                              reintroduce the class */
      return true;
    }

    /* PATH 2 — manual swap, for theme versions without that method. */
    var host = document.querySelector('#CartDrawer');
    if (host && sections && sections['cart-drawer']) {
      var fresh = extractSection(sections['cart-drawer'], '#CartDrawer');
      if (fresh) host.innerHTML = fresh;

      clearEmptyState();

      if (drawer) {
        drawer.classList.add('animate', 'active');
        if (typeof drawer.open === 'function') drawer.open();
      }
      document.body.classList.add('overflow-hidden');
      return true;
    }

    return false;   /* Neither path worked — caller falls back to the cart */
  }

  /* Refreshes the little count bubble on the header cart icon. */
  function refreshBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    var fresh = extractSection(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && fresh) bubble.innerHTML = fresh;
  }

  /* ─── WIRE UP ONE SECTION INSTANCE ──────────────────────── */

  function initSection(root) {
    if (root.dataset.sjyReady) return;   /* Guard against double-binding
                                            when the theme editor re-renders */
    root.dataset.sjyReady = '1';

    /* Routes passed in from Liquid via data attributes. Falls back to the
       default paths if an attribute is somehow missing. */
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl    = root.getAttribute('data-cart-url') || '/cart';

    /* TAB SWITCHING — one listener on the tab bar rather than one per
       button (event delegation). Fewer listeners, survives DOM changes. */
    var tabBar = root.querySelector('.sjy-oc__tabs');
    var tabs   = root.querySelectorAll('.sjy-oc__tab');
    var panels = root.querySelectorAll('.sjy-oc__panel');

    if (tabBar) {
      tabBar.addEventListener('click', function (e) {
        /* closest() walks up from the click target to find the button, so
           a click on the label text inside it still registers. */
        var btn = e.target.closest('.sjy-oc__tab');
        if (!btn) return;

        var index = btn.getAttribute('data-sjy-tab');

        /* Deactivate everything, then activate the match. Simpler and
           less bug-prone than tracking the previous state. */
        tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.setAttribute('aria-selected', 'true');
        var target = root.querySelector('[data-sjy-panel="' + index + '"]');
        if (target) target.classList.add('is-active');
      });
    }

    /* ─── ADD TO CART → DRAWER ────────────────────────────── */

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.sjy-oc__atc');
      if (!btn) return;

      var variantId = btn.getAttribute('data-sjy-add');
      if (!variantId) return;   /* Sold-out button has no ID — ignore it */

      e.preventDefault();       /* Stops the plain form submit, which would
                                   navigate away to the cart page */

      btn.classList.add('is-loading');   /* Blocks double-clicks mid-request */
      var original = btn.textContent;
      btn.textContent = 'Adding…';

      function reset() {
        btn.classList.remove('is-loading');
        btn.textContent = original;
      }

      /* TWO-STEP, deliberately.
         Step 1 adds the item. Step 2 fetches the drawer markup in a
         separate request. Asking for 'sections' inside the POST is one
         round trip fewer, but it renders the sections against the root
         URL rather than the current page, and returns stale or missing
         markup in some theme setups — which is the other half of the
         blank-drawer problem. Fetching separately against the real
         pathname always returns correct markup. */

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {

        if (data.status) {   /* Shopify returns 'status' only on error,
                                e.g. stock ran out mid-session */
          reset();
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = original; }, 2000);
          return null;
        }

        /* STEP 2 — fetch the re-rendered drawer against the current URL */
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        if (!sections) return;   /* Error path already handled above */

        reset();
        refreshBubble(sections);

        /* If the drawer can't open for any reason, send them to the cart
           page rather than silently doing nothing. */
        if (!openDrawer(sections)) window.location.href = cartUrl;
      })
      .catch(function () {
        /* Network failure — fall back so the add isn't lost */
        reset();
        window.location.href = cartUrl;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sjy-oc]').forEach(initSection);
  }

  /* Run now if the DOM is ready, otherwise wait for it. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor re-renders sections without a page reload, which
     would otherwise leave the new markup unbound. These re-run setup. */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
